import { render, staticRenderFns } from "./introduce-detail.vue?vue&type=template&id=2564662a&scoped=true&"
import script from "./introduce-detail.vue?vue&type=script&lang=js&"
export * from "./introduce-detail.vue?vue&type=script&lang=js&"
import style0 from "./introduce-detail.vue?vue&type=style&index=0&id=2564662a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564662a",
  null
  
)

export default component.exports